import { VerticalContainer } from "@shared/designSystem/Containers";
import { H1Title, H2Title } from "@shared/designSystem/Titles";
import { HollowedButton } from "@shared/designSystem/Button";
import { ImageWithPlaceholder } from "@shared/designSystem/ImageWithPlaceholder";
import { designSystemStyles } from "@shared/styles/designSystemStyles";
import { useProfileScreenViewModel } from "./ProfileScreenViewModel";

export const ProfileScreen: React.FC = () => {
    const { displayName, imageURL, openHelpCenter, logOut } = useProfileScreenViewModel();

    return (
        <VerticalContainer
            gap={designSystemStyles.gapMd}
            paddingLeft={designSystemStyles.paddingLg}
            paddingTop={designSystemStyles.paddingLg}
            alignment="left"
        >
            <H1Title text="Mi Perfil" />
            <VerticalContainer gap={designSystemStyles.gapSm} justifyContent="flex-start" alignment="left">
                <H2Title text={displayName} />
                <ImageWithPlaceholder
                    url={imageURL}
                    width="200px"
                    height="200px"
                    borderRadius={designSystemStyles.cornerRadiusComponent}
                    placeholderColor={designSystemStyles.colorPlaceholderBackground}
                    alt={displayName}
                />
            </VerticalContainer>
            <HollowedButton text="Centro de Ayuda" onClick={openHelpCenter} width="200px"/>
            <HollowedButton text="Cerrar sesión" onClick={logOut} width="200px" />
        </VerticalContainer>
    );
};

export default ProfileScreen;
